import React, { useMemo, useState } from 'react';
import { Utils, Query, Builder } from '@react-awesome-query-builder/ui';
import {
  booleanOperators,
  config as builderConfig,
  fields,
  numberOperators
} from '../config.js';
import { AntdConfig } from '@react-awesome-query-builder/antd';
import { connect } from 'react-redux';

const checkReturnTypeOfFunc = (func) => {
  if (func.functionName === 'match') {
    return 'boolean';
  }
  if (fields[func.args.field]?.type === 'datetime') {
    return 'datetime';
  }
  if (
    func.functionName === 'aggregation' &&
    (func.args.aggregationFunction?.toLowerCase() === 'sum' ||
      func.args.aggregationFunction?.toLowerCase() === 'min' ||
      func.args.aggregationFunction?.toLowerCase() === 'max' ||
      func.args.aggregationFunction?.toLowerCase() === 'average' ||
      func.args.aggregationFunction?.toLowerCase() === 'average_count' ||
      func.args.aggregationFunction?.toLowerCase() === 'count' ||
      func.args.aggregationFunction?.toLowerCase() === 'count_distinct' ||
      func.args.aggregationFunction?.toLowerCase() === 'collect_set')
  ) {
    return 'number';
  }
  return 'boolean';
};

const generateUniqueVariantId = () => {
  const timestamp = new Date().getTime();
  const randomValue = Math.random();
  const uniqueId = `${timestamp}_${randomValue}`;
  return uniqueId;
};

const QueryBuilder = ({
  queryValue = null,
  type = '',
  setVariantRenderData,
  typoIndex,
  variantIndex,
  functionIndex,
  variantInfo,
  isReadOnly,
  allowNewIfEmpty,
  blackListData = [],
  onDirtyField
}) => {
  const blackList = useMemo(
    () =>
      blackListData
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((f) => ({
          title: f.name,
          value: f.name
        })),
    [blackListData]
  );

  const allFunc =
    (variantInfo.function &&
      variantInfo.function.reduce((arr, o) => {
        return {
          ...arr,
          [o['name']]: {
            label: o['name'],
            operators:
              checkReturnTypeOfFunc(o) === 'boolean'
                ? booleanOperators
                : numberOperators,
            type: checkReturnTypeOfFunc(o)
          }
        };
      }, {})) ||
    {};
  const [tree, setTree] = useState(
    Utils.checkTree(
      Utils.loadTree(
        queryValue || { id: generateUniqueVariantId(), type: 'group' }
      ),
      {
        ...builderConfig(blackList, variantInfo.function),
        fields: {
          ...builderConfig(blackList, variantInfo.function).fields,
          ...allFunc
        }
      }
    )
  );
  const [config, setConfig] = useState({
    ...builderConfig(blackList, variantInfo.function),
    fields: {
      ...builderConfig(blackList, variantInfo.function).fields,
      ...allFunc
    },
    settings: {
      ...builderConfig(blackList, variantInfo.function).settings,
      showErrorMessage: true,
      setOpOnChangeField: 'default',
      canReorder: !isReadOnly,
      canRegroup: !isReadOnly,
      immutableGroupsMode: isReadOnly,
      immutableFieldsMode: isReadOnly,
      immutableOpsMode: isReadOnly,
      immutableValuesMode: isReadOnly,
      addRuleLabel: type !== 'condition' ? 'Add Trigger' : 'Add Condition'
    }
  });

  const renderBuilder = (props) => (
    <div className="query-builder-container">
      <div className="query-builder qb-lite">
        <Builder {...props} />
      </div>
    </div>
  );

  const onChange = (immutableTree, config) => {
    setTree(tree);
    setConfig(config);
    const jsonTree = Utils.getTree(immutableTree);
    // Utils.validateTree(immutableTree)
    setVariantRenderData((prev) => {
      let dataToSet = prev;
      if (type === 'functionAggregation') {
        dataToSet[typoIndex].variants[variantIndex][type] = jsonTree;
      }
      if (type === 'condition') {
        dataToSet[typoIndex].variants[variantIndex][type] = jsonTree;
      }
      if (type === 'aggregationCondition') {
        dataToSet[typoIndex].variants[variantIndex].function[
          functionIndex
        ].args[type] = jsonTree;
      }
      return [...dataToSet];
    });
    onDirtyField();
  };

  if (!queryValue && !allowNewIfEmpty) {
    return <></>;
  }
  return (
    <Query
      {...config}
      value={tree}
      onChange={onChange}
      renderBuilder={renderBuilder}
    />
  );
};

function mapStateToProps(state, ownProps = {}) {
  return {
    blackListData: state.trmDashboard.blackList?.data?.payload || []
  };
}

export default connect(mapStateToProps, null)(QueryBuilder);
